import $ from 'jquery';
import { useState } from "react";
import { useSelector } from "react-redux";
import AddEmployee from "./AddEmployee";

const EmployeeMasterData = ({ setEmpId, setShow, setView, setCurrentVal, searchTerm, sortConfig }) => {
    $(function () {
        $(".clickable-row ").on("click", function () {
            $(this).next(".folded-data").toggleClass("open");
        });
    });

    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();
    const loading = useSelector((state) => state.teammanagement.loading)
    // const error = useSelector((state) => state.teammanagement.error)
    const employeeData = useSelector((state) => state.teammanagement.data.employee)
    // const [modalShow, setModalShow] = useState(false);

    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setShowOffcanvas(!showOffcanvas);
        setOperation("update")
    };


    const handleDelete = (id, event) => {
        event.stopPropagation();
        setShow(true);
        setEmpId(id);
    }

    const handleView = (curEmpData, event) => {
        event.stopPropagation();
        setView(true);
        setCurrentVal(curEmpData)
    }


    const filteredData = employeeData.results
        ? employeeData.results.filter((curData) => {
            const { id, name, department_name, supervisor, employee_designation, status } = curData;
            return (
                id?.toString().includes(searchTerm) ||
                name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                department_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                supervisor?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                employee_designation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (status ? 'active' : 'inactive').toLowerCase().includes(searchTerm.toLowerCase())
            );
        })
        : [];

    const sortedData = filteredData.sort((a, b) => {
        if (sortConfig.key) {
            const order = sortConfig.direction === 'asc' ? 1 : -1;
            return a[sortConfig.key] > b[sortConfig.key] ? order : -order;
        }
        return 0;
    });

    return (
        <>
            {
                sortedData.length > 0 ? (
                    sortedData.map((curData => {
                        const { id, name, department_name, supervisor, employee_designation, status } = curData;
                        return (
                            <>
                                <tr
                                    key={id}
                                    // onClick={() => handleRowClick(curData)}
                                    className={`clickable ${selectedRow.id === id ? 'selected' : ''}`}
                                >
                                    <td>{id}</td>
                                    <td>{name}</td>
                                    {/* <td>{email}</td> */}
                                    {/* <td>{contact}</td> */}
                                    <td>{department_name}</td>
                                    <td>{supervisor}</td>
                                    <td>{employee_designation}</td>
                                    <td style={{ color: "green",paddingLeft:"30px" }}><span><b>{status ? 'Active' : 'Inactive'}</b></span></td>
                                    {/* <div className="folded-data"> */}
                                    <td><button className="custom-button" onClick={() => handleEditClick(curData)}>
                                        <i class="fa-solid fa-pencil" style={{color:"darkslateblue"}}></i></button></td>
                                    <td><button className="custom-button" onClick={(event) => handleDelete(id, event)}>
                                        <i class="fa fa-trash" aria-hidden="true"style={{color:"red"}}></i></button></td>
                                    <td><button className="custom-button" onClick={(event) => handleView(curData, event)}>
                                        <i class="fa fa-eye" aria-hidden="true"style={{color:"darkslateblue"}}></i></button></td>
                                    {/* </div> */}
                                </tr>
                                {/* <Button variant="primary" onClick={() => setModalShow(true)}>
                                Launch vertically centered modal
                            </Button>

                            <MyVerticallyCenteredModal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                            /> */}
                                {/* <Accordion.Item eventKey={id}>
                                <Accordion.Header className='accordianrow-emp'>
                                    <span>{id}</span>
                                    <span>{name}</span>
                                    <span>{email}</span>
                                    <span>{contact}</span>
                                    <span>{department_name}</span>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="folded-data">
                                        <span><b>Superviser</b>{supervisor}</span>
                                        <span><b>Designation</b>{employee_designation}</span>
                                        <span><b>User Status</b>{status ? 'Active' : 'Inactive'}</span>
                                        <span><b>Edit</b><button onClick={() => handleEditClick(curData)}><i class="fa-solid fa-pencil"></i></button></span>

                                    </div>
                                </Accordion.Body>
                            </Accordion.Item> */}
                            </>
                        )
                    }))) : (
                    <span>No Employee data available.</span>
                )
            }
            <AddEmployee
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />
        </>
    )
}

export default EmployeeMasterData;

